import * as yup from "yup";

const useClientXmlFileSchema = () => yup.object({ batchName: yup.string() });

export default useClientXmlFileSchema;
